const HAS_URL = typeof URL !== 'undefined';

export default HAS_URL;